import React, { useState } from "react"
import { flowRight as compose } from "lodash"
import {
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  CardHeader,
  CardFooter,
  Alert
} from "reactstrap"
import AsyncSelect from "react-select/async"
import { withBasicNotify } from "components/notification"
import { withRouter } from "react-router"
import { BackButton } from "components/utility"
import { BarLoader } from "components/spinner"
import { useQuery, useMutation } from "@apollo/react-hooks"
// eslint-disable-next-line no-unused-vars
import {
  GET_PRODUCTS,
  // eslint-disable-next-line no-unused-vars
  GET_COMPANIES,
  UPDATE_PRICEBOOK,
  CREATE_PRICEBOOK
} from "../gql"

const PricebookForm = (props) => {
  const [localData, setLocalData] = useState(
    props.data
      ? {
          price: props.data[0]?.price,
          company: props.data[0]?.company?.id,
          product: props.data[0]?.product?.id
        }
      : {
          price: "",
          company: "",
          product: ""
        }
  )

  const { data: productsData, refetch: _getProducts } = useQuery(GET_PRODUCTS, {
    fetchPolicy: "network-only",
    variables: { take: 10, skip: 0 }
  })
  // const { data: companiesData, refetch: _getCompanies } = useQuery(GET_PRODUCTS, {
  //   fetchPolicy: "network-only",
  //   variables: { take: 10, skip: 0 }
  // })
  const [
    // eslint-disable-next-line no-unused-vars
    updatePriceBook,
    { loading: updateLoading, error: updateError }
  ] = useMutation(UPDATE_PRICEBOOK)
  const [
    // eslint-disable-next-line no-unused-vars
    createPriceBook,
    { loading: createLoading, error: createError }
  ] = useMutation(CREATE_PRICEBOOK)

  const [searchCustFilter, setSearchCustFilter] = useState({
    product: "",
    company: ""
  })

  const checkRequire = () => {
    return (
      localData.price === "" ||
      localData.company === "" ||
      localData.product === ""
    )
  }

  const onFieldChange = (key, value) => {
    setLocalData({
      ...localData,
      [key]: value
    })
  }

  // const variableFromData = () => {
  //   return {
  //     id: localData.id || undefined,
  //     input: {
  //       price: localData.price,
  //       company: localData.company,
  //       product: localData.product
  //     }
  //   }
  // }

  const onSaveButtonClick = async () => {
    // if (localData.id) {
    //   await updatePriceBook({
    //     variables: variableFromData()
    //   })
    // } else {
    //   await createPriceBook({
    //     variables: variableFromData()
    //   })
    // }

    props.history.goBack()
  }

  const renderSaveButton = () => {
    return (
      <Button
        color="primary"
        disabled={checkRequire()}
        onClick={onSaveButtonClick}
      >
        送出
      </Button>
    )
  }

  // const loadCompanyOptions = (inputValue, callback) => {
  //   setTimeout(async () => {
  //     const data = await _getCompanies({
  //       take: 10,
  //       skip: 0,
  //       input: { name: searchCustFilter?.product }
  //     })

  //     callback(
  //       data?.data?.products?.data?.map((item) => {
  //         return { label: item?.name, value: item?.id }
  //       })
  //     )
  //   }, 2000)
  // }

  const loadProductOptions = (inputValue, callback) => {
    setTimeout(async () => {
      const data = await _getProducts({
        take: 10,
        skip: 0,
        input: { name: searchCustFilter?.product }
      })

      callback(
        data?.data?.products?.data?.map((item) => {
          return { label: item?.name, value: item?.id }
        })
      )
    }, 2000)
  }

  return (
    <div className="">
      <Card>
        <CardHeader>
          <BackButton left />
        </CardHeader>
        <CardBody>
          <Form
            style={{
              marginLeft: "10px",
              marginRight: "10px"
            }}
          >
            <FormGroup row>
              <Label for="price">價格 *</Label>
              <Input
                type="text"
                name="price"
                id="price"
                placeholder="名稱"
                value={localData?.price || ""}
                onChange={(e) => onFieldChange("price", e.target.value)}
              />
            </FormGroup>
            {/* <FormGroup row>
              <Label for="product">公司</Label>
              <div style={{ width: "100%" }}>
                <AsyncSelect
                  type="select"
                  name="company"
                  id="company"
                  value={
                    companiesData?.companies?.data
                      .filter(function (item) {
                        return item.id === localData?.company
                      })
                      .map((o) => ({
                        label: o.name,
                        value: o.id
                      })) || [{}]
                  }
                  cacheOptions
                  loadOptions={loadCompanyOptions}
                  defaultOptions={companiesData?.products?.data.map((o) => ({
                    label: o.name,
                    value: o.id
                  }))}
                  onInputChange={(text) => {
                    setSearchCustFilter({
                      ...searchCustFilter,
                      company: text.trim()
                    })
                  }}
                  onChange={(e) => {
                    onFieldChange("company", e?.value)
                  }}
                ></AsyncSelect>
              </div>
            </FormGroup> */}
            <FormGroup row>
              <Label for="product">產品</Label>
              <div style={{ width: "100%" }}>
                <AsyncSelect
                  type="select"
                  name="product"
                  id="product"
                  value={
                    productsData?.products?.data
                      .filter(function (item) {
                        return item.id === localData?.product
                      })
                      .map((o) => ({
                        label: o.name,
                        value: o.id
                      })) || [{}]
                  }
                  cacheOptions
                  loadOptions={loadProductOptions}
                  defaultOptions={productsData?.products?.data.map((o) => ({
                    label: o.name,
                    value: o.id
                  }))}
                  onInputChange={(text) => {
                    setSearchCustFilter({
                      ...searchCustFilter,
                      product: text.trim()
                    })
                  }}
                  onChange={(e) => {
                    onFieldChange("product", e?.value)
                  }}
                ></AsyncSelect>
              </div>
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter>
          <div>{renderSaveButton()}</div>
        </CardFooter>
        <BarLoader loading={updateLoading || createLoading} />
      </Card>
      {(createError || updateError) && (
        <Alert color="danger">
          錯誤訊息：{`${createError || updateError}`}
        </Alert>
      )}
    </div>
  )
}

export default compose(withBasicNotify, withRouter)(PricebookForm)
